export default (...sets) => new Set(sets.flatMap((s) => Array.from(s)));
//# sourceMappingURL=union.mjs.map